import type { INotificationIcon } from './helpers';

export const NotificationIcon = ({ variant = 'default', ...rest }: INotificationIcon) => (
	<svg
		width='40'
		height='41'
		viewBox='0 0 40 41'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<rect
			y='0.192383'
			width='40'
			height='40'
			rx='20'
			fill={variant === 'default' ? 'var(--color-neutral-100)' : 'var(--color-error-50)'}
		/>
		<path
			opacity='0.4'
			d='M27.3399 22.6828L26.3399 21.0228C26.1299 20.6528 25.9399 19.9528 25.9399 19.5428V17.0128C25.9399 13.7528 23.2899 11.0928 20.0199 11.0928C16.7499 11.0928 14.0999 13.7528 14.0999 17.0128V19.5428C14.0999 19.9528 13.9099 20.6528 13.6999 21.0128L12.6899 22.6828C12.2899 23.3528 12.1999 24.0928 12.4499 24.7728C12.6899 25.4428 13.2599 25.9628 13.9999 26.2128C15.9399 26.8728 17.9799 27.1928 20.0199 27.1928C22.0599 27.1928 24.0999 26.8728 26.0399 26.2228C26.7399 25.9928 27.2799 25.4628 27.5399 24.7728C27.7999 24.0828 27.7299 23.3228 27.3399 22.6828Z'
			fill={variant === 'default' ? 'var(--color-primary-400)' : 'var(--color-error-400)'}
		/>
		<path
			d='M22.2498 11.5124C21.5598 11.2424 20.8098 11.0924 20.0198 11.0924C19.2398 11.0924 18.4898 11.2324 17.7998 11.5124C18.2298 10.7024 19.0798 10.1924 20.0198 10.1924C20.9698 10.1924 21.8098 10.7024 22.2498 11.5124Z'
			fill={variant === 'default' ? 'var(--color-primary-400)' : 'var(--color-error-400)'}
		/>
		<path
			d='M22.8297 28.2024C22.4097 29.3624 21.2997 30.1924 19.9997 30.1924C19.2097 30.1924 18.4297 29.8724 17.8797 29.3024C17.5597 29.0024 17.3197 28.6024 17.1797 28.1924C17.3097 28.2124 17.4397 28.2224 17.5797 28.2424C17.8097 28.2724 18.0497 28.3024 18.2897 28.3224C18.8597 28.3724 19.4397 28.4024 20.0197 28.4024C20.5897 28.4024 21.1597 28.3724 21.7197 28.3224C21.9297 28.3024 22.1397 28.2924 22.3397 28.2624C22.4997 28.2424 22.6597 28.2224 22.8297 28.2024Z'
			fill={variant === 'default' ? 'var(--color-primary-400)' : 'var(--color-error-400)'}
		/>
	</svg>
);
